import styles from "./PLayLogsTableLine.module.css"
import cs from "clsx"
import moment from "moment"
import { Playlogs } from "../lib/playlogs"
import { useEffect, useLayoutEffect, useState } from "react"
import { DotsVertical, Pause, Play } from "heroicons-react";
import { RatingModal } from "../rating";
import logo from "../../../assets/images/flogo.png";
import { ModalChangeClient } from "../../../components/layout/Page/Header/change-client";
interface Props {
  className: string
  playlog: Playlogs
  serviceName: string | undefined
  togglePlay: any
  playing: any
}

export function PLayLogsTableLine({ className, playlog, serviceName, playing, togglePlay }: Props) {
  let playUrl = "";
  const [showModal, setShowModal] = useState(false)
  const [playStatus, setPlayStatus] = useState(false)
  const [currentFileName, setCurrentFileName] = useState("")
  const [audio] = useState(new Audio(""))
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };
  function play(filename: any) {
    setPlayStatus(true)
    setCurrentFileName(filename)
    playing(filename)
    if (filename.substring(filename.length - 4) === ".enc") {
      filename = filename.replace(".enc", ".mp3")
    }
    if (filename.includes("mp3")) {
      playUrl = "https://preview.mcubedigital.com/audio/" + filename
    } else {
      playUrl = "https://preview.mcubedigital.com/audio/" + filename + ".mp3"
    }

    audio.setAttribute("src", playUrl)
    audio.play()
    setTimeout(stop, 30000)
  }
  function stop() {
    setPlayStatus(false)
    if (audio) {
      audio.setAttribute("src", "") //change the source
      audio.load()
    }
  }
  useLayoutEffect(() => {
    return () => {
      stop()
    }
  }, [])
  useEffect(() => {
    if (currentFileName !== togglePlay) {
      stop()
    }
  }, [togglePlay])
  return (
    <div className={styles.root + " " + cs(styles.bg, className)}>
      <div></div>
      <div className={styles.column + " " + styles.column_70}>
        {playlog?.mediaName?.includes(":") ? (
          <span>
            <div>
              <span className={styles.MainTitle}>{playlog?.mediaName?.slice(0, playlog?.mediaName?.search(":"))}</span>
            </div>
            <div>
              <span className={styles.MainTitle}>{playlog?.mediaName?.slice(1 + playlog?.mediaName?.search(":"))}</span>
            </div>
          </span>
        ) : (
          <div>
            <span className={styles.MainTitle}>{playlog?.mediaName}</span>
          </div>
        )}
        <div>
          <span className={styles.status}>{moment(playlog?.startTime).format("DD/MM/yyyy")}</span>
          <span className={styles.status}>{moment(playlog?.startTime).format("HH:mm:ss")}</span>
        </div>
      </div>
      <div className={styles.column + " " + styles.column_10}>
        {serviceName === "Audio" && (
            <div className={styles.preview}>
            {!playStatus && <Play size={45} onClick={() => play(playlog.filename)}></Play>}
            {playStatus && <Pause size={45} onClick={stop}></Pause>}
          </div>
        )}
      </div>
      {/*<div className={styles.column + " " + styles.column_2}>*/}
      {/*  /!*<DotsVertical onClick={() => setShowModal(true)}></DotsVertical>*!/*/}
      {/*  /!*{showModal && <RatingModal showModal={showModal}  playlog={playlog} hideModal={() => setShowModal(false)}></RatingModal>}*!/*/}
      {/*</div>*/}
    </div>
  )
}
